import React from "react";
import "./COEPillars.css";
import {
  FaFlask,
  FaGraduationCap,
  FaUsers,
  FaLightbulb,
  FaUniversity,
  FaDesktop,
  FaRulerCombined,
  FaBolt,
  FaWifi,
  FaChalkboard,
  FaChair,
  FaPaperPlane,
  FaPhone,
} from "react-icons/fa";

export default function COEPillars() {
  return (
    <div className="coe-wrapper">
      <div className="coe-grid">

        {/* ===== FIVE PILLARS ===== */}
        <div className="card">
          <div className="card-header">
            <span className="dot green"></span>
            <h4>FIVE PILLARS OF THE COE</h4>
          </div>

          <div className="card-body">
            <div className="pillar">
              <div className="pill-icon pi-purple"><FaFlask /></div>
              <div className="pillar-text">
                <h5>Innovation Lab</h5>
                <p>7 Robots · 20 Kits · 1200 sq.ft.</p>
              </div>
            </div>
            <div className="pillar">
              <div className="pill-icon pi-blue"><FaGraduationCap /></div>
              <div className="pillar-text">
                <h5>Training &amp; Curriculum</h5>
                <p>Embedded · IoT · AI/ML · Robotics</p>
              </div>
            </div>
            <div className="pillar">
              <div className="pill-icon pi-green"><FaUsers /></div>
              <div className="pillar-text">
                <h5>Expert Engagement</h5>
                <p>Bi-annual visits · Industry talks</p>
              </div>
            </div>
            <div className="pillar">
              <div className="pill-icon pi-orange"><FaLightbulb /></div>
              <div className="pillar-text">
                <h5>Research &amp; IP</h5>
                <p>Patents · SIH · Robocon · DST funds</p>
              </div>
            </div>
            <div className="pillar">
              <div className="pill-icon pi-teal"><FaUniversity /></div>
              <div className="pillar-text">
                <h5>Institutional Benefits</h5>
                <p>NBA / NAAC · MoU · IP Portfolio</p>
              </div>
            </div>
          </div>
        </div>

        {/* ===== PAYMENT TERMS ===== */}
        <div className="card">
          <div className="card-header">
            <span className="dot blue"></span>
            <h4>PAYMENT TERMS</h4>
          </div>

          <div className="card-body">
            <div className="payment-list">

              <div className="payment-step">
                <div className="step-left">
                  <span className="circle c-purple">01</span>
                  <div className="step-line"></div>
                </div>
                <div className="pay-text">
                  <h5>On Purchase Order</h5>
                  <p>75% advance — work begins within 3 working days</p>
                </div>
              </div>

              <div className="payment-step">
                <div className="step-left">
                  <span className="circle c-navy">02</span>
                  <div className="step-line"></div>
                </div>
                <div className="pay-text">
                  <h5>Setup &amp; Delivery</h5>
                  <p>Complete lab ready within 30 days — guaranteed timeline</p>
                </div>
              </div>

              <div className="payment-step last">
                <div className="step-left">
                  <span className="circle c-green">03</span>
                </div>
                <div className="pay-text">
                  <h5>After Installation</h5>
                  <p>25% balance due within 7 days of successful acceptance</p>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* ===== INSTITUTION MUST PROVIDE ===== */}
        <div className="card">
          <div className="card-header">
            <span className="dot orange"></span>
            <h4>INSTITUTION MUST PROVIDE</h4>
          </div>

          <div className="card-body inst-body">
            <div className="inst-grid">
              <div className="inst-item">
                <FaDesktop className="inst-icon blink-1" />
                <span>25+ Computers</span>
              </div>
              <div className="inst-item">
                <FaRulerCombined className="inst-icon blink-2" />
                <span>750–1200 sq.ft.</span>
              </div>
              <div className="inst-item">
                <FaBolt className="inst-icon blink-3" />
                <span>3-Phase + UPS</span>
              </div>
              <div className="inst-item">
                <FaWifi className="inst-icon blink-4" />
                <span>50 Mbps Internet</span>
              </div>
              <div className="inst-item">
                <FaChalkboard className="inst-icon blink-5" />
                <span>Projector / Board</span>
              </div>
              <div className="inst-item">
                <FaChair className="inst-icon blink-6" />
                <span>Seating for 50</span>
              </div>
            </div>
          </div>
        </div>

      </div>

      {/* ===== BUTTONS ===== */}
      <div className="actions">
        <button className="btn-primary" onClick={() => {
  document.getElementById('lab-enquiry-form')?.scrollIntoView({ behavior: 'smooth' });
}}>
  <FaPaperPlane className="btn-icon" />
  Request a Proposal
</button>
        <button className="btn-secondary" onClick={() => window.open('https://ibots.in/our-contacts/', '_blank')}>
  <FaPhone className="btn-icon" />
  Call Us
</button>
      </div>
    </div>
  );
}